var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app" },
    [
      _c("div", { staticClass: "DisplayBox" }, [
        _c("div", { staticClass: "Display" }, [
          _c("p", [_vm._v(_vm._s(_vm.tateData.integral))]),
          _vm._v(" "),
          _c("span", [_vm._v("当前积分")])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "Dxian" }),
        _vm._v(" "),
        _c("div", { staticClass: "Display" }, [
          _c("p", [_vm._v(_vm._s(_vm.tateData.usintegral))]),
          _vm._v(" "),
          _c("span", [_vm._v("可用积分")])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "Exchange" }, [
        _c("div", { staticClass: "ExctopBOX" }, [
          _c("div", { staticClass: "ExcLnt" }, [
            _c("p", [_vm._v("兑换积分")]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.integral,
                  expression: "integral"
                }
              ],
              attrs: { type: "number" },
              domProps: { value: _vm.integral },
              on: {
                input: [
                  function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.integral = $event.target.value
                  },
                  _vm.inputMony
                ],
                focus: _vm.focus,
                blur: _vm.blur
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "ExcAmo" }, [
            _c("p", [
              _vm._v("\n          兑换金额:\n          "),
              _c("span", { staticStyle: { color: "#46a1ff" } }, [
                _vm._v(_vm._s(_vm.mony))
              ]),
              _vm._v("元\n        ")
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                on: {
                  click: function($event) {
                    return _vm.clickMoney(_vm.tateData.usintegral)
                  }
                }
              },
              [_vm._v("兑换")]
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "ExcbotBox" }, [
          _c("span", [_vm._v("积分兑换比例:" + _vm._s(_vm.tateData.bl))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "ExcRec" }, [
        _c("span", { staticClass: "Rec" }, [_vm._v("兑换记录")]),
        _vm._v(" "),
        _c("i", {
          staticClass: "iconfont iconxia",
          on: { click: _vm.clickZankai }
        }),
        _vm._v(" "),
        _c("span", { staticClass: "Recqb" }, [
          _c("span", { on: { click: _vm.clickZankai } }, [
            _vm._v(_vm._s(_vm.catName))
          ]),
          _vm._v(" "),
          _c(
            "div",
            { class: [_vm.zankai == true ? "tanchu zankai" : "tanchu"] },
            _vm._l(_vm.categoryData, function(item, index) {
              return _c(
                "div",
                {
                  key: index,
                  on: {
                    click: function($event) {
                      return _vm.clickCat(item.num, item.name)
                    }
                  }
                },
                [_vm._v(_vm._s(item.name))]
              )
            }),
            0
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          ref: "Bonus",
          staticClass: "BonusPoiBox",
          on: { scroll: _vm.scrollEvent }
        },
        _vm._l(_vm.ExcData, function(item, index) {
          return _c("div", { key: index, staticClass: "Exclist" }, [
            _c("div", { staticClass: "ExclistReward" }, [
              _c("span", [_vm._v(_vm._s(item.DSC))]),
              _vm._v(" "),
              _c("span", { staticClass: "ExclistReward_right" }, [
                _vm._v(_vm._s(item.QTY))
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "ExcDat" }, [_vm._v(_vm._s(item.DAT))])
          ])
        }),
        0
      ),
      _vm._v(" "),
      _vm.binding ? _c("div", { staticClass: "borBox" }) : _vm._e(),
      _vm._v(" "),
      _vm.binding
        ? _c("div", { staticClass: "Choice" }, [
            _c("div", { staticClass: "cho1" }, [_vm._v("确认是否兑换")]),
            _vm._v(" "),
            _c("div", { staticClass: "cho2" }, [
              _c(
                "div",
                {
                  staticStyle: { "border-right": "1px solid #e0e0e0" },
                  on: {
                    click: function($event) {
                      return _vm.clickBinding(false)
                    }
                  }
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  on: {
                    click: function($event) {
                      return _vm.clickBinding(true)
                    }
                  }
                },
                [_vm._v("确定")]
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("Return"),
      _vm._v(" "),
      _vm.prom ? _c("Promptbox", { attrs: { message: _vm.Tips } }) : _vm._e(),
      _vm._v(" "),
      _vm.load ? _c("loading") : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2020f6ff", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2020f6ff","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/exchange/index.vue
// module id = null
// module chunks = 